export default __webpack_public_path__ + "static/media/eyesofset.e1942981.png";